<template>
	<div class="flex-fill d-flex overflow-hidden">
		<div v-if="showLoader" class="loader1">
			<div>
				<div class="lds-ripple">
				<div></div>
				<div></div>
				</div>
			</div>
		</div>
		<transition name="collapse-width">
			<!-- <div v-show="showList" :class="{ 'd-flex flex-column': showList }" > -->
			<div class="forIpadUIConvo d-flex flex-column">
				<div id="groupConvoList" class="bg-white border flex-fill d-flex flex-column overflow-hidden">
					
					<div class="d-flex1 p-3 border-bottom" style="padding-bottom: 20px!important;">
						<div class="flex-fill position-relative" style="width:64%;">
							<b-input type="text" placeholder="Search Group Conversations..." autocomplete="off" v-model="search" debounce="500" 
							style="margin-right:6px; float:left; padding-right: 30px;" @keyup="onKeyFilter()" 
							/>
							<button v-if="resetGroupFilterbtn" class="resetGroupFilterCls" @click="resetGroupFilter();"><v-icon name="times" class="icongrey" /></button>
						</div>
						
						<button class="btn btn-primary createGroupbtn" @click="$bvModal.show('CreateGroupModal')"><v-icon name="plus" class="text-white" style="font-size:12px;" /></button>
					
						<b-dropdown variant="outline" right toggle-class="mr-1 filterpaddcls">
							<template v-slot:button-content>
								<b class="filterHead">Filter</b>
							</template>
							<b-dropdown-group style="max-height: 30em; overflow-y: auto">
								<h6 class="text-center text-blue">Defaults</h6>
								<b-dropdown-item-button v-if="sort != 0" @click="filterClick(0)">Recent</b-dropdown-item-button>
								<b-dropdown-item-button v-if="sort != 1" @click="filterClick(1)">Oldest</b-dropdown-item-button>
								<b-dropdown-item-button v-if="sort != 2" @click="filterClick(2)">Unread</b-dropdown-item-button>
								<!-- <b-dropdown-item-button v-if="sort != 3" @click="filterClick(3)">Due Task</b-dropdown-item-button> -->
								<b-dropdown-item-button v-if="sort != 4" @click="sortByStarred()">Starred</b-dropdown-item-button>
								<!-- <b-dropdown-item-button v-if="sort != 5" @click="filterClick(5)">Scheduled</b-dropdown-item-button> -->
								
								<hr>
								<div v-if="user.Folders">
									<h6 class="text-center text-blue">Folders</h6>
									<b-dropdown-item-button
										:key="i"
										@click="sortByFolder(i)"
										v-for="i in user.Folders.length"
									>
										<span v-if="sort != 5 + i">{{user.Folders[i - 1]}}</span>
									</b-dropdown-item-button>
									<hr>
								</div>
								
								<div v-if="user.Stages">
									<h6 class="text-center text-blue">Stages</h6>
									<b-dropdown-item-button
										:key="i + user.Folders.length"
										@click="sortByStage(i);"
										v-for="i in user.Stages.length"
									>
										<span v-if="sort != 5 + user.Folders.length + i">{{user.Stages[i - 1]}}</span>
									</b-dropdown-item-button>
									<b-dropdown-item-button @click="sort = -1" v-if="sort != -1">
										Archived
									</b-dropdown-item-button>
								</div>
								<!--
								<hr>
								<div>
									<h6 class="text-center text-blue">Assessment</h6>
									
									
									<b-dropdown-item-button @click="sortByPriority(1)">Priority:1 </b-dropdown-item-button>
									<b-dropdown-item-button @click="sortByPriority(2)">Priority:2 </b-dropdown-item-button>
									<b-dropdown-item-button @click="sortByPriority(3)">Priority:3 </b-dropdown-item-button>
								</div>-->
							</b-dropdown-group>
						</b-dropdown>
						
						
						<div v-if="nomatches" class="nomatches">No Matches</div>
					</div>
					


					<!-- <div style="padding-bottom: 18px;" class="d-flex p-3 border-bottom">
						<div class="flex-fill position-relative">
							<b-input type="text" placeholder="Search Group Conversations..." v-model="search" debounce="500" 
							style="margin-right:6px; width: 80%; float:left; padding-right: 30px;" @keyup="onKeyFilter()" 
							/> -->
							<!-- <b-list-group class="text-center position-absolute w-100">
								<b-list-group-item
									class="py-2"
									:key="prosp.id"
									style="z-index: 1000"
									v-for="prosp in filteredProspects"
									button @click="openSearch(prosp)"
								>
									{{$parseAlias(prosp)}}
								</b-list-group-item>
							</b-list-group> -->
							<!-- <button v-if="resetGroupFilterbtn" class="resetGroupFilterCls" @click="resetGroupFilter();"><v-icon name="times" class="icongrey" /></button> -->
							<!-- <button class="btn btn-primary" @click="groupFilterSearch();"><v-icon name="search" class="text-white" style="font-size:12px;" /></button> -->

							<!-- <button class="btn btn-primary createGroupbtn" @click="$bvModal.show('CreateGroupModal')"><v-icon name="plus" class="text-white" style="font-size:12px;" /></button>
							<div v-if="nomatches" class="nomatches">No Matches</div>
						</div> -->
						
					<!-- </div> -->
					<b-modal id="CreateGroupModal" hide-footer>
						<template v-slot:modal-title>
							Create New Group
						</template>
						<div class="CreateGroupModalInsideDiv">
							<b-form>
								<b-form-group label-cols="4" label="Title:" class="my-1 mb-3">
									<b-form-input
										type="text"
										placeholder="Enter Title"
										v-model="friendlyName"
									/>
								</b-form-group>
								<b-form-group label-cols="4" label="Select Prospects:" class="my-2">
								<multiselect 
									v-model="selectedProspectValue" 
									tag-placeholder="Enter Prospects" 
									placeholder="Search Prospects"
									:options="getProspectNames" 
									:multiple="true" 
									:hideSelected="true"
									:showLabels='false'
									label="name" 
									track-by="code"
									>
								</multiselect>
							</b-form-group>
								<b-button block variant="outline-primary" class="mt-4 createNewGroupBtn" @click="createNewGroup">Save</b-button>
							</b-form>
						</div>
					</b-modal>
					<div v-if="sort == 0 || sort == 1 || sort == 2 || sort == 3 || sort == 5" ref="groupConvoList" class="flex-fill overflow-auto position-relative yscrollbar" id="yscrollbarstyle-1">
						<groupConversationItem
							:active="activegroupConvo == groupconvo.id"
							:key="groupconvo.id"
							v-for="groupconvo in sortedConvos"
							:filter="sort"
							:groupconvo="groupconvo"
							@groupopen="opengroupConvo"
						/>
						<h6 v-if="!sortedConvos.length" class="center text-black-50">No Group Conversations</h6>
					</div>
					<div v-if="sort == 4 || sort > 5" ref="groupConvoList" v-on:scroll="OnScroll" class="flex-fill overflow-auto position-relative">
						<groupConversationItem
							:active="activegroupConvo == groupconvo.id"
							:key="groupconvo.id"
							v-for="groupconvo in filteredConvos"
							:filter="sort"
							:groupconvo="groupconvo"
							@groupopen="opengroupConvo"
							:isPriorityClicked="isPriorityClicked"
						/>
						<h5 v-if="!filteredConvos.length" class="center text-black-50">No Group Conversations</h5>
					</div>
				</div>
			</div>
		</transition>
		<groupMessageLog id="grpMessageLog"  :groupconvo="groupconvo" @groupopen="changePage" @showLoader="manageLoader"   @getCallDetails="getCallDetails"/>
		
		<div v-if="groupconvo" v-show="page == 'prosp'" transition="collapse-width">
			<div  :class="{ 'd-flex flex-column': page == 'prosp' }">
				<div id="Prospect" class="bg-white border flex-fill d-flex flex-column overflowY-auto">
					<groupProspect
						:groupProspectData="groupconvo"
						:insideAddNewProspectList="insideAddNewProspectList"
						:number="'+12062784141'"
						@groupopen="changePage"
						@delete="deleteGroup"
						@showLoader="manageLoader"
					/>
				</div>
			</div>
		</div>
		<!-- <div v-if="groupconvo || prosp" v-show="page == 'prosp'" transition="collapse-width">
			<div  :class="{ 'd-flex flex-column': page == 'prosp' }">
				<div id="Prospect" class="bg-white border flex-fill d-flex flex-column overflowY-auto">
					<groupProspect
						:prospect="prosp"
						:number="prosp ? prosp.Number : groupconvo.UserNumber"
						@groupopen="changePage"
						@delete="deleteProsp"
						@showLoader="manageLoader"
					/>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import axios from "axios";
	import groupConversationItem from './subcomponents/groupConversationItem'
	import groupMessageLog from './subcomponents/groupMessageLog'
	import groupProspect from './subcomponents/groupProspect'
	import { mapState } from 'vuex'
	import { db,getPhoneData } from 'src/db.js'
	import Multiselect from 'vue-multiselect'

	export default {
		name: "groupConversation",
		components: {
			groupConversationItem,
			groupMessageLog,
			Multiselect,
			groupProspect
		},
		computed: {
			getProspectNames() {
				let names = [];
				for (let p of this.prospects) {
					if (p.First && p.Last) {
						names.push({ name: p.First+' '+p.Last, code: p.Number });
					}
				}
				return names;
			},
			insideAddNewProspectList() {
				let myprospects = [];
				Object.assign(myprospects, this.prospects);
				let one = this.groupconvos.find(convo1 => convo1.id == this.activegroupConvo);
				let myProspAvailableInGroup = one.ProspectNumbers;
				return myprospects.filter((m) => !myProspAvailableInGroup.includes(m.Number));
			},
			// convo() {
			// 	if (!this.activeConvo) {
			// 		return null;
			// 	}
			// 	return this.convos.find(convo => convo.id == this.activeConvo);
			// },
			// newParticipantloop() {
			// 	let myprospects = [];
			// 	Object.assign(myprospects, this.prospects);
			// 	let myProspAvailableInGroup = this.groupProspectData.ProspectNumbers;
			// 	const filterMyProspects = myprospects.filter((m) => !myProspAvailableInGroup.includes(m.Number));
			// 	//eslint-disable-next-line
			// 	console.log('filterMyProspects',filterMyProspects);
			// 	return filterMyProspects;
			// },
			groupconvo() {
				//eslint-disable-next-line
				// console.log('this.activegroupConvo', this.activegroupConvo);
				//eslint-disable-next-line
				// console.log('this.groupconvos', this.groupconvos);
				
				if (!this.activegroupConvo) {
					return null;
				}
				// var aa = this.groupconvos.find(convo1 => convo1.id == this.activegroupConvo);
				//eslint-disable-next-line
				// console.log('aa', this.activegroupConvo);
				return this.groupconvos.find(convo1 => convo1.id == this.activegroupConvo);
			},
			prosp() {
				//eslint-disable-next-line
				console.log('prosp:> ', this.activegroupProsp);
				if (!this.activegroupProsp) {
					return null;
				}
				return this.prospects.find(prosp => prosp.id == this.activegroupProsp);
			},
			showList() {
				return this.page == 'list' ||
					(this.page == 'convo' && this.format == 'big');
			},
			filteredProspects() {
				if (!this.search) {
					return [];
				}
				let prospMatches = this.prospects.filter(prosp => {
					let ret = false;
					if (prosp.Number) {
						ret = prosp.Number.includes(this.search) ||
								this.$parseNumber(prosp.Number).includes(this.search);
					}
					return ret || this.$parseAlias(prosp).toLowerCase().includes(this.search.toLowerCase());
				});
				if (prospMatches.length == 0) {
					return [{First: 'No', Last: 'Matches'}];
				}
				return prospMatches.slice(0, 8);
			},
			sortedConvos() {
				let convos = this.groupconvos;

				//eslint-disable-next-line
				//console.log('sortedConvos function call...');

				// case 1-2-default
				// .slice(0, 30 * this.convoListHeight)
				// let convos = this.convos.slice(0, 30 * this.convoListHeight);
				// if (this.emails.length) {
				// 	for (let convo of convos) {
				// 		let findp = this.prospects.find(p => p.Number == convo.ClientNumber);						
				// 		if (findp) {
				// 			convo.prospId = findp.id;
				// 			let finde = this.emails.find(e => e.ProspectID == convo.prospId);
				// 			if (finde) {
				// 				convo.isMailExist = true;
				// 				convo.emailConvoID = finde.id;
				// 				if (convo.Unread == 0) {
				// 					convo.Unread = finde.Unread;
				// 				}
				// 				if (convo.DateUpdated < finde.DateUpdated) {
				// 					convo.EmailDateUpdated = finde.DateUpdated;
				// 					// convo.DateUpdated = finde.DateUpdated;
				// 				}
				// 			}
				// 		}
				// 	}
				// }
				// this.makeLoaderTrue();
				switch (this.sort) {
					case 0:
						//eslint-disable-next-line
						//console.log('case 0');	
						return this.sortByRecent();
					case 1:
						//eslint-disable-next-line
						//console.log('case 1');	
						// return convos.sort((a, b) => a.DateUpdated - b.DateUpdated).slice(0, 30 * this.convoListHeight);
						return this.sortByOldest();
					case 2:
						//eslint-disable-next-line
						//console.log('case 2', this.groupconvos);
						return convos.filter(convo => convo.Unread).slice(0, 30 * this.groupconvoListHeight);
						// return this.sortByUnread(convos)
					case 3:
						//eslint-disable-next-line
						//console.log('case 3');
						return this.sortByDueTask(convos).slice(0, 30 * this.groupconvoListHeight);
					case 4:
						//eslint-disable-next-line
						//console.log('case 4');
						return this.sortByStarred()
					case 5:
						//eslint-disable-next-line
						//console.log('case 5');
						return this.sortByScheduled(convos)
					
					default:
						//eslint-disable-next-line
						//console.log('case default');
						return this.sortByFolder();
				}
				
			},
			// ...mapState('globals', ['scrollTop', 'activeConvo', 'activegroupConvo', 'activeProsp', 'activegroupProsp', 'format']),
			...mapState('globals', ['groupScrollTop', 'activegroupConvo', 'activegroupProsp', 'format']),
			...mapState('firebase', ['prospects', 'groupconvos', 'user'])
			// ...mapState('firebase', ['prospects', 'convos', 'user'])
		},
		methods: {
			// ON LOAD ADD GEOUP NAME FOR FILTER PURPOSE
			onLoadAssignTempGroupName() {
				this.updateNameInGroupConvo = [];
				Object.assign(this.updateNameInGroupConvo,this.groupconvos);
				this.updateNameInGroupConvo.forEach(gc => {
					let tempArr = [];
					gc.ProspectNumbers.filter(uo => {
						let s = this.prospects.find(pr => pr.Number == uo);
						if(s) {
							tempArr.push(s.First+' '+s.Last);
						} else {
							tempArr.push();
						}
						// tempArr.push(s.First+' '+s.Last);
					});
					gc['name'] = tempArr;
				});
			},
			// CREATE NEW GROUP (POPUP)
			createNewGroup() {
				let selectedProspNum = [];
				this.selectedProspectValue.forEach(sp =>{
					selectedProspNum.push(sp.code);
				});
				if(selectedProspNum.length) {
					this.showLoader = true;
					this.$bvModal.hide('CreateGroupModal');
					const dataPass = {
						friendlyName: this.friendlyName,
						ParticipantAddress: selectedProspNum,
						ProjectedAddress: this.user.Twilio
					};
					//eslint-disable-next-line
					//console.log('dataPass', dataPass);
					axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/createNewGroup", dataPass)
					//axios.post("http://localhost:5000/tatext-thirdpool-development/us-central1/tatext/createNewGroup", dataPass)
					.then(response => {
						this.showLoader = false;
						this.friendlyName = '';
						this.selectedProspectValue = [];
						//eslint-disable-next-line
						console.log('createNewGroup API response', response);
					}).catch((error) => {
						alert(error.response.data.error);
						//eslint-disable-next-line
						//console.log('errror', error.response.data.error);
						this.showLoader = false;
						this.friendlyName = '';
						this.selectedProspectValue = [];
					});
				}
			},
			// makeLoaderTrue() {
			// 	this.showLoader = true;
			// },
			OnScroll() {
				let component = this.$refs.groupConvoList;
				if (component.groupScrollTop + component.offsetHeight > component.scrollHeight - 1) {
					this.groupconvoListHeight++;
					if (this.sort == 4 || this.sort > 5) {
						this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.groupconvoListHeight);
					}
				}
			},
			async sortByFolder(i) {
				//eslint-disable-next-line
				// console.log('i', i);
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.convoListHeight =  1;
				this.sort = 5 + i;
				let iFolder = this.sort - 6;
				let convo = [];
				
				if (iFolder >= 0) {
					let val1 = this.user.Folders[iFolder];
					if (val1) {
						let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Tags', 'array-contains', val1).get();
						colRef.docs.map((doc) => {
							let data = { id: doc.id, ...doc.data() };	

							let tempArray1 = [];
							tempArray1.push(data.Number);

							tempArray1.forEach(ma => {
								this.groupconvos.filter(ma11 => {
									var check = ma11.ProspectNumbers.includes(ma);
									if(check) {
										convo.push(ma11);
									}
								});
							});

							return data;
						});
					}

				}
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.convoListHeight);
				//eslint-disable-next-line
				// console.log('this.filteredConvos>>>>', this.filteredConvos);
				this.showLoader = false;
			},
			async sortByStage(i) {
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.convoListHeight =  1;
				this.sort = 5 + this.user.Folders.length + i;
				let numFolders = this.user.Folders ? this.user.Folders.length : 0;
				let iStage = this.sort - numFolders - 6;
				let convo = [];
				if (iStage >= 0) {
					let val = this.user.Stages[iStage];
					if (val) {
						let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Status', '==', val).get();
						colRef.docs.map((doc) => {
							let data = { id: doc.id, ...doc.data() };

							/*let c = this.convos.find(convo => convo.ClientNumber == data.Number);
							if (c) {
								convo.push(c)
							}*/

							let tempArray2 = [];
							tempArray2.push(data.Number);

							tempArray2.forEach(ma => {
								this.groupconvos.filter(ma11 => {
									var check1 = ma11.ProspectNumbers.includes(ma);
									if(check1) {
										convo.push(ma11);
									}
								});
							});

							return data;
						});
					}
				}

				this.allFilteredConvos = convo;
				
				//eslint-disable-next-line
				//console.log(this.allFilteredConvos);
				
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.convoListHeight);
				this.showLoader = false;
			},
			/*async sortByPriority(p) {
				this.isPriorityClicked = true;
				this.sort =  5 + this.user.Folders.length + this.user.Stages.length + p;
				this.showLoader = true;
				this.convoListHeight =  1;
				let convo = [];
				let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('CciMap.Priority', '==', p).get();
				colRef.docs.map((doc) => {
					let data = { id: doc.id, ...doc.data() };
					let c = this.convos.find(convo => convo.ClientNumber == data.Number);
					if (c) {
						convo.push(c)
					}
					return data;
				});
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.convoListHeight);
				this.showLoader = false;
			},*/
			sortByOldest() {
				// var cnv = [];
				// Object.assign(cnv,convos) ;
				// for (let c of cnv) {
				// 	if (c.hasOwnProperty('EmailDateUpdated')) {
				// 		c.DateUpdated =  c.EmailDateUpdated;
				// 	}
				// }
				// let convos = this.convos.slice(0, 30 * this.convoListHeight);
				// if (this.emails.length) {
				// 	convos = this.filterEmailConvo(convos)
				// }
				this.isPriorityClicked = false;
				this.showLoader = false;
				return this.groupconvos.sort((a, b) => a.DateUpdated - b.DateUpdated).slice(0, 30 * this.groupconvoListHeight);
			},
			sortByRecent() {
				// var cnv = [];
				// Object.assign(cnv,convos) ;
				// for (let c of cnv) {
				// 	if (c.hasOwnProperty('EmailDateUpdated')) {
				// 		c.DateUpdated =  c.EmailDateUpdated;
				// 	}
				// }
				this.isPriorityClicked = false;
				let convos;
				if(this.makeFilterConvo.length){
					convos = this.makeFilterConvo.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.groupconvoListHeight);
				} else {
					convos = this.groupconvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.groupconvoListHeight);
				}
				// if (this.emails && this.emails.length) {
				// 	convos = this.filterEmailConvo(convos)
				// }
				this.onLoadAssignTempGroupName();
				return convos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.groupconvoListHeight);
			},
			// filterEmailConvo(convos) {
			// 	for (let convo of convos) {
			// 		let findp = this.prospects.find(p => p.Number == convo.ClientNumber);						
			// 		if (findp) {
			// 			convo.prospId = findp.id;
			// 			let finde = this.emails.find(e => e.ProspectID == convo.prospId);
			// 			if (finde) {
			// 				convo.isMailExist = true;
			// 				convo.emailConvoID = finde.id;
			// 				if (convo.Unread == 0) {
			// 					convo.Unread = finde.Unread;
			// 				}
			// 				if (convo.DateUpdated < finde.DateUpdated) {
			// 					// convo.EmailDateUpdated = finde.DateUpdated;
			// 					convo.DateUpdated = finde.DateUpdated;
			// 				}
			// 			}
			// 		}
			// 	}
			// 	return convos
			// },
			filterClick(sort) {
				this.sort = sort;
				this.convoListHeight=1;
				this.$refs.groupConvoList.scrollTop = 0;

				//eslint-disable-next-line
				// console.log('this.sort', this.sort);
				
			},
			getCallDetails(value) {
				this.$emit('getCallDetails',value);
			},
			opengroupConvo(grpconvoId, grpprospId) {

				//eslint-disable-next-line
				//console.log('opengroupConvo');

				//eslint-disable-next-line
				console.log('convoId', grpconvoId);
				//eslint-disable-next-line
				console.log('prospId', grpprospId);

				// this.$store.commit('globals/SET', { var: 'activegroupProsp', val: grpprospId });
				this.$store.commit('globals/SET', { var: 'activegroupConvo', val: grpconvoId });
				this.$store.dispatch('firebase/bindGroupMessages', grpconvoId);
				
				this.changePage('convo');
				if (this.prosp) {
					if (!Object.keys(this.prosp).includes('CarrierType')) {
						getPhoneData({Number:this.prosp.Number})
						.then(res => this.showPhoneData(res))
						.catch(err => this.showPhoneError(err));
					}
				}
				
			},
			showPhoneData(res) {
				let phoneData = JSON.parse(res.data);
				db.doc(`Users/${this.user.id}/Prospects/${this.prosp.id}`).update({CarrierType:phoneData.carrier.type})
			},
			showPhoneError(err) {
				alert(`Not able to find prospect Number Type : `+ err)
				db.doc(`Users/${this.user.id}/Prospects/${this.prosp.id}`).update({CarrierType:null})
			},
			deleteGroup() {
				if (confirm("Are you sure you want to delete group?")) {
				const dataPass = {
					ConversationSid: this.activegroupConvo
				};
				//eslint-disable-next-line
				// console.log('dataPass', dataPass);
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/deleteConversations", dataPass)
				.then(response => {
					this.changePage('list');
					this.$store.commit('globals/CLEAR', 'activegroupConvo');
					//eslint-disable-next-line
					console.log('Conversation Successfully Deleted', response);
				}).catch(err => alert(`Erro In Conversation Deleted: ${err}`));

				//eslint-disable-next-line
				// console.log('Delete Group', this.activegroupConvo);

				}
			},
			// async deleteProsp() {
			// 	if (confirm("You are about to permanently remove this prospect and all conversation and email data!\n\nAre you sure you want to proceed?")) {
			// 		db.doc(`Users/${this.user.id}/Prospects/${this.activeProsp}`).delete();
			// 		db.doc(`Conversations/${this.activeConvo}`).delete();

			// 		const cnvref = await db.collection('Emails').where('ProspectID', '==', this.activeProsp).get();
			// 		cnvref.docs.forEach(doc => {
			// 			doc.ref.delete();
			// 		});

			// 		this.changePage('list');
			// 	}
			// },
			resetGroupFilter() {
				this.search = '';
				this.resetGroupFilterbtn = false;
				this.makeFilterConvo = [];
				this.nomatches = false;
			},
			onKeyFilter() {
				setTimeout(() => {
					if(this.search.length > 0 && this.search) {
						this.groupFilterSearch();
					} else {
						this.makeFilterConvo = [];
						this.resetGroupFilterbtn = false;
						this.nomatches = false;
					}
				}, 500);
			},

			groupFilterSearch() {

				this.makeFilterConvo = [];
				this.updateNameInGroupConvo.forEach(gc1 => {
					let a = 0;
					gc1.name.filter(uo1 => {
						if(a == 0) {
							let ret = false;
							ret = uo1.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
							if(ret) {
								this.makeFilterConvo.push(gc1);
								a = 1;
							}
						}
					});
				});

				if(this.makeFilterConvo.length == 0) {
					this.nomatches = true;
					this.resetGroupFilterbtn = true;
				} else {
					this.nomatches = false;
					this.resetGroupFilterbtn = true;
				}
			},

			// testt(nume) {	
			// 	// if(this.search){
			// 	// 	return this.groupconvos.filter((item)=>{
			// 	// 		return item.First.indexOf(this.searchQuery) > -1 || item.Last.indexOf(this.searchQuery) > -1;
			// 	// }
			// 	this.makeFilterConvo = [];
			// 	this.groupconvos.forEach(ma => {
			// 		var check = ma.ProspectNumbers.includes(nume);
			// 		if(check) {
			// 			this.makeFilterConvo.push(ma);
			// 		}
			// 		//eslint-disable-next-line
			// 		console.log('makeFilterConvo', this.makeFilterConvo);
			// 	});
			// },
			// async openSearch(prosp) {
			// 	this.search = '';
			// 	this.testt(prosp.Number);
			// },
			async oldopenSearch(prosp) {
				this.search = '';
				let convo = this.groupconvos.find(convo => convo.UserNumber == prosp.Number);
				if (!convo) {
					convo = await db.collection('Conversations_v2').add({
						ClientNumber: prosp.Number,
						AgentNumber: this.user.Twilio,
						Uid: this.user.Uid,
						LastMessage: '',
						DateUpdated: 0,
						Unread: 0
					});
				}
				this.$store.commit('globals/SET', { var: 'activegroupProsp', val: prosp.id });
				// this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
				this.$store.commit('globals/SET', { var: 'activegroupConvo', val: convo.id });
				
				this.changePage('convo');
			},
			changePage(target) {
				if (target == 'list' && this.format != 'big') {
					//eslint-disable-next-line
					console.log('ONE');
					this.$store.commit('globals/CLEAR', 'activegroupProsp');
					// this.$store.commit('globals/CLEAR', 'activeConvo');
					this.$store.commit('globals/CLEAR', 'activegroupConvo');
				}
				if (this.page == 'list' || (this.page == 'convo' && this.format == 'big')) {
					//eslint-disable-next-line

					// this.abc();
					
					this.$store.commit('globals/SET', { var: 'groupScrollTop', val: this.$refs.groupConvoList.groupScrollTop });
				}
				this.page = target;
			},
			scroll() {
				this.$refs.groupConvoList.onscroll = () => {
					let component = this.$refs.groupConvoList;
					if (component.groupScrollTop + component.offsetHeight > component.scrollHeight - 1) {
						this.groupconvoListHeight++;
					}
				};
			},
			sortByDueTask(convos) {
				
				//eslint-disable-next-line
				// console.log('convos1111', convos);

				this.isPriorityClicked = false;
				let dueConvos = [];
				

				for (let convo of convos) {
					//eslint-disable-next-line
					console.log('convo', convo);
					let findProps = this.prospects.find(props => props.Number == convo.ClientNumber);
					
					// this.convo.forEach(gc => {
					// 	let c = gc.ProspectNumbers.find(convo1 => convo1 == data.Number);
					// 	//eslint-disable-next-line
					// 	// console.log('cc', c);
					// 	if(c) {
					// 		dueConvos.push(gc);
					// 	}
					// });

					
					if (this.isOverDue(findProps)) {
						dueConvos.push(convo)
					}
				}

				return dueConvos
			},
			async sortByStarred() {
				//eslint-disable-next-line
				// console.log('datadat2a');
				this.isPriorityClicked = false;
				this.sort = 4;
				this.showLoader = true;
				this.groupconvoListHeight =  1;
				let convo = [];
				let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Starred', '==', true).get();
				//eslint-disable-next-line
				// console.log('colRefcolRef', colRef);
				colRef.docs.map((doc) => {
					let data = { id: doc.id, ...doc.data() };

					//eslint-disable-next-line
					// console.log('colRefcolRef', coldataRef);

					// let tempArr1 = [];
					this.groupconvos.forEach(gc => {
						let c = gc.ProspectNumbers.find(convo1 => convo1 == data.Number);
						//eslint-disable-next-line
						// console.log('cc', c);
						if(c) {
							convo.push(gc);
						}
					});

					//eslint-disable-next-line
					// console.log('convoconvo', convo);
					//eslint-disable-next-line
					// console.log('datadata', data);
					
						
					// let c = this.groupconvos.find(convo => convo.ProspectNumbers == data.Number);
					// //eslint-disable-next-line
					// console.log('convo', data.Number);
					// if (c) {
					// 	convo.push(c)
					// }

					return data;
				});

				
				
				this.allFilteredConvos = convo;

				//eslint-disable-next-line
				//console.log('this.allFilteredConvos', this.allFilteredConvos);

				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.groupconvoListHeight);
				this.showLoader = false;
			},
			sortByScheduled (convos) {
				this.isPriorityClicked = false;
				let scheduledConvos = [];
				for (let convo of convos) {
					//eslint-disable-next-line
					// console.log('convoq', convo);
					if (convo.hasOwnProperty('ScheduledCount') && convo.ScheduledCount) {
						scheduledConvos.push(convo)
					}
				}
				return scheduledConvos
			},
			sortByUnread(convos) {
				this.isPriorityClicked = false;
				return convos.filter(convo => convo.Unread).slice(0, 30 * this.groupconvoListHeight);
			},
			isOverDue(findProps) {
				let val = false;
				if(findProps && findProps.Tasks) {
					for (let task of findProps.Tasks) {
						if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now() || this.isToday(new Date(task.DueOn)))) {
							val = true;
							break	
						}
					}
					
				}
				return val
			},
			isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
			},
			manageLoader() {
				this.showLoader = !this.showLoader;
			}
		},
		watch: {
			showList: {
				immediate: true,
				handler(showList) {
					if (showList) {
						this.$nextTick(() => {
							this.$refs.groupConvoList.groupScrollTop = this.groupScrollTop;
						})
					}
				}
			}
		},
		data() {
			return {
				updateNameInGroupConvo: [],
				nomatches:false,
				resetGroupFilterbtn:false,
				makeFilterConvo:[],
				selectedProspectValue:[],
				groupconvoListHeight: 1,
				page: 'list',
				search: '',
				sort: 0,
				showLoader:false,
				filteredConvos:[],
				allFilteredConvos:[],
				isPriorityClicked:false,
				friendlyName:'',
			}
		},
		mounted() {
			this.scroll();
		},
		// beforeRouteLeave(to, from, next) {
		// 	this.$store.commit('globals/SET', { var: 'scrollTop', val: this.$refs.groupConvoList.scrollTop });
		// 	next();
		// }
	}
</script>

<style scoped>
	.createGroupbtn{
		font-size: 13px;
		padding: 6px 10px;
	}
	#groupConvoList {
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 1001;
	}
	#Prospect {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		/* z-index: 1001; */
	}
	.active {
		background-color: #E5E5E5;
	}
    .collapse-width-enter,
    .collapse-width-leave-to{
        max-width: 0;
    }
    .collapse-width-leave,
    .collapse-width-enter-to{
        max-width: 35em;
    }
    .collapse-width-enter-active,
    .collapse-width-leave-active{
        transition: all .5s ease;
    }

	.resetGroupFilterCls, .resetGroupFilterCls:focus, .resetGroupFilterCls:active{
		position: absolute;
		right: 10px;
		top: 5px;
		background: #fff;
		border: none;
		outline: none;
		box-shadow: none;
	}
	.icongrey{
		color:#7385ab;
	}
	.nomatches{
		font-size: 13px;
	}

	.loader1 {
position: fixed;
z-index: 1010;
top: 50%;
margin: auto;
left: 50%;
z-index: 1111;
}

.FilterDiv{
	float:right;
}

.loader1:before {
content: "";
display: block;
position: fixed;
top: 0;
left: 0;
width: 100%;
min-height: 100%;
background-color: rgba(0, 0, 0, 0.3);
z-index: 1111;
}

.lds-ripple {
display: inline-block;
top: 50%;
position: relative;
width: 64px;
height: 64px;
}

.lds-ripple div {
position: absolute;
top: 50%;
border: 4px solid #000000;
opacity: 1;
border-radius: 50%;
animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
animation-delay: -0.5s;
}

@keyframes lds-ripple {
0% {
top: 28px;
left: 28px;
width: 0;
height: 0;
opacity: 1;
}
100% {
top: -1px;
left: -1px;
width: 58px;
height: 58px;
opacity: 0;
}
}
</style>
<style>
.CreateGroupModalInsideDiv{
	padding: 5px 3px 20px 3px;
}
.createNewGroupBtn{
	height: 40px;
}
.filterpaddcls{
	padding:5px!important;
}
</style>